import {
    HttpClient,
    HttpParams
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseRestService} from './baseRestService';
import {environment} from 'src/environments/environment';
import {
    bespokeCase,
} from "../../classes/BespokePolicy";
import {CaseFilter} from "../../classes/CaseFilter";
import {CasePagination} from "../../classes/user";
import {Case} from "../../classes/Case";
import {DraftStatusResponse} from "../../classes/DraftStatusResponse";
import {
    CancellationRequest
} from "../../classes/CancellationRequest";
import {map} from "rxjs/operators";
import {
    CreateDraftResponse,
    CreateOrderResponse
} from "../../classes/rest-classes/CreateCaseResponse";
import {
    CreatePipaDraftRequest,
    CreatePipaOrderRequest
} from "../../classes/CreatePipaDraftRequest";

@Injectable({
    providedIn: 'root',
})

export class RestCasesService extends BaseRestService {
    private readonly BASE_URL: string;

    constructor(private http: HttpClient) {
        super();
        this.BASE_URL = environment.restApiUrl + '/Cases';
    }


    public postPipaOrder(caseFileId: number, request: CreatePipaOrderRequest): Observable<CreateOrderResponse> {
        return this.http.post<CreateOrderResponse>(this.BASE_URL + `/${caseFileId}/PipaOrder`, request, {headers: this.authHeadersV2});
    }

    public postPipaDraft(caseFileId: number, request: CreatePipaDraftRequest): Observable<CreateDraftResponse> {
        return this.http.post<CreateDraftResponse>(this.BASE_URL + `/${caseFileId}/PipaDraft`, request, {headers: this.authHeadersV2});
    }

    public sendLiBespokeRequest(bespokeData: bespokeCase): Observable<any> {
        return this.http.post<any>(this.BASE_URL, bespokeData, {headers: this.authHeadersV2});
    }

    public addBespokeToExistingCase(bespokeData: bespokeCase, caseId: number): Observable<any> {
        const url = `${this.BASE_URL}/${caseId}/Quotes`;
        return this.http.post<any>(url, bespokeData, {headers: this.authHeadersV2});
    }

    getCasesByFilter(caseFilter: CaseFilter, statusData: any, accountUserId: string): Observable<CasePagination> {
        const url = `${this.BASE_URL}/List`;
        let params = new HttpParams()
            .set('PageNumber', caseFilter.pageNumber.toString())
            .set('AccountId', caseFilter.accountid.toString())
            .set('AccountUserId', accountUserId);

        params = params.append('OrderStatuses', statusData)

        if (caseFilter.fromdate) params = params.set('FromDate', caseFilter.fromdate.replace(/"/g, ''));
        if (caseFilter.todate) params = params.set('ToDate', caseFilter.todate.replace(/"/g, ''));
        if (caseFilter.casereference) params = params.set('CaseReference', caseFilter.casereference);
        if (caseFilter.postcode) params = params.set('Postcode', caseFilter.postcode);
        if (caseFilter.orderid) params = params.set('OrderId', caseFilter.orderid.toString());
        if (caseFilter.ponumber) params = params.set('PoNumber', caseFilter.ponumber.toString());
        if (caseFilter.casetype) params = params.set('CaseTypeId', caseFilter.casetype.toString());
        if (caseFilter.mattertype) params = params.set('MatterTypeId', caseFilter.mattertype.toString());
        if (caseFilter.datasubject) params = params.set('DataSubject', caseFilter.datasubject);
        if (caseFilter.globalsearch) params = params.set('GlobalSearch', caseFilter.globalsearch);
        if (caseFilter.casefileid) params = params.set('CaseFileId', caseFilter.casefileid);

        return this.http.get<CasePagination>(url, {headers: this.authHeadersV2, params});
    }

    getCase(caseId: number): Observable<Case> {
        const url = `${this.BASE_URL}/${caseId}/PipaCase`;
        return this.http.get<Case>(url, {headers: this.authHeadersV2});
    }

    public placeBespokeOrder(caseFileBespoke: bespokeCase, caseId?: number): Observable<any> {
        const url = `${this.BASE_URL}/${caseId}/Quotes`;
        return this.http.post(url, caseFileBespoke, {headers: this.authHeadersV2});
    }

    public getDraftStatus(lineGuid: string): Observable<DraftStatusResponse> {
        let params = new HttpParams().set('lineGuid', lineGuid);
        return this.http.get<DraftStatusResponse>(this.BASE_URL + `/GetDraftStatus`, {params: params, headers: this.authHeadersV2});
    }

    hasDraftExpired(lineGuid: string): Observable<boolean> {
        let params = new HttpParams().set('lineGuid', lineGuid);
        return this.http.get<boolean>(this.BASE_URL + `/HasDraftExpired`, {params: params, headers: this.authHeadersV2});
    }

    updateLineType(lineGuid: string, lineTypeId: number): Observable<boolean> {
        let params = new HttpParams().set('lineGuid', lineGuid).set('lineTypeId', lineTypeId);
        return this.http.post<boolean>(this.BASE_URL + `/UpdateLineType`,null, {params: params, headers: this.authHeadersV2});
    }


    requestOrderDetailCancel(caseId: number, orderId: number, cancelRequest: CancellationRequest) {
        return this.http.post(this.BASE_URL + `/${caseId}/Orders/${orderId}/Cancel`, cancelRequest, {headers: this.authHeadersV2}).pipe(map(res => {
            return res['success'];
        }));
    }
}